import Env from "../Env/Env";

class Logger {

    /**
     * @returns {boolean}
     */
    static useConsole() {
        return !Env.isProd();
    }

    /**
     *
     * @returns {*}
     */
    static getErrorObject() {
        try {
            throw Error('')
        } catch (err) {
            return err;
        }
    }

    /**
     * @param message
     * @param optionalParams
     */
    static log(message, ...optionalParams) {

        if (!this.useConsole()) {
            return;
        }

        //Get Caller
        const err = this.getErrorObject();
        const caller_line = err.stack.split("\n")[4];
        const index = caller_line.indexOf("at ");
        window.console.log('Logged: ' + caller_line.slice(index + 2, caller_line.length));

        //Console
        window.console.log(message, ...optionalParams);
    }

    /**
     * @param message
     * @param optionalParams
     */
    static error(message, ...optionalParams) {
        if (!this.useConsole()) {
            return;
        }

        //Get Caller
        const err = this.getErrorObject();
        const caller_line = err.stack.split("\n")[4];
        const index = caller_line.indexOf("at ");
        window.console.log('Logged: ' + caller_line.slice(index + 2, caller_line.length));

        //Console
        window.console.error(message, ...optionalParams);
    }

}

export default Logger;
